// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CounterpartyDataMerged extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  counterpartyDataId!: number;
  accountId?: number;
  adminId?: number;
  counterpartyId!: number;
  createdBy!: string;
  createdDate!: Date;
  creditorId?: number;
  data?: string;
  ddata?: Date;
  fdata?: number;
  fieldLookupId!: number;
  flags?: number;
  subType?: number;
  ts?: string;
  updatedBy!: string;
  updatedDate!: Date;
}

